import React, { useState, useEffect } from "react";

export default function VerizonHeader() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  if (isMobile) return <MobileHeader />;
  return <DesktopHeader />;
}

function MobileHeader() {
  return (
    <header style={m.header}>
      {/* Top bar: logo + icons */}
      <div style={m.topBar}>
        <svg viewBox="0 0 100 30" width="110" height="34" style={{ display: "block" }}>
          <text x="0" y="26" fontFamily="Arial Black, sans-serif" fontWeight="1000" fontSize="28" fill="#cd040b">verizon</text>
        </svg>
        <div style={m.icons}>
          {/* Search */}
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" style={{ cursor: "pointer" }}>
            <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
          </svg>
          {/* Sign in text */}
          <span style={m.signIn}>Sign in</span>
          {/* Cart */}
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" style={{ cursor: "pointer" }}>
            <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          {/* Hamburger */}
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2" style={{ cursor: "pointer" }}>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </div>
      </div>
      {/* Call us bar */}
      <div style={m.callBar}>
        <div style={m.callLeft}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.22h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.96-.96a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
          <span style={m.callText}>Call Us: 1-800-VERIZON</span>
        </div>
        <button style={m.buyBtn}>Buy now</button>
      </div>
    </header>
  );
}

function DesktopHeader() {
  return (
    <header style={d.header}>
      <div style={d.topBar}>
        <span style={d.redTopLink}>Personal</span>
        <span style={d.topLink}>Business</span>
        <span style={d.topSpacer} />
        <span style={d.topLink}>1-833-VERIZON</span>
        <span style={d.topLink}>Contact us</span>
        <span style={d.topLink}>Support</span>
        <span style={d.topLink}>Stores</span>
        <span style={d.topLink}>Coverage map</span>
        <span style={d.topLink}>Español</span>
      </div>
      <div style={d.mainNav}>
        <div style={d.logo}>
          <svg viewBox="0 0 100 30" width="11rem" height="40" style={{ display: "block" }}>
            <text x="0" y="26" fontFamily="Arial Black, sans-serif" fontWeight="1000" fontSize="28" fill="#cd040b">verizon</text>
          </svg>
        </div>
        <nav style={d.navLinks}>
          <span style={d.navLink}>Mobile</span>
          <span style={d.navLink}>Home Internet</span>
          <span style={d.navLink}>Shop</span>
          <span style={d.navLink}>Deals</span>
        </nav>
        <div style={d.navRight}>
          <div style={d.searchBox}>
            <span style={d.searchText}>Search Verizon</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#333" strokeWidth="2">
              <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
            </svg>
          </div>
          <span style={d.signInLink}>Sign in</span>
        </div>
      </div>
    </header>
  );
}

/* ── Mobile styles ── */
const m = {
  header: { background: "#fff", borderBottom: "1px solid #e0e0e0" },
  topBar: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px",
  },
  icons: { display: "flex", alignItems: "center", gap: 16 },
  signIn: { fontSize: 14, fontWeight: 700, color: "#000", cursor: "pointer" },
  callBar: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 16px",
    borderTop: "1px solid #e0e0e0",
    background: "#fff",
  },
  callLeft: { display: "flex", alignItems: "center", gap: 8 },
  callText: { fontSize: 13, color: "#000", fontWeight: 400 },
  buyBtn: {
    background: "#000", color: "#fff",
    border: "none", borderRadius: 4,
    padding: "8px 18px", fontWeight: 700,
    fontSize: 13, cursor: "pointer",
  },
};

/* ── Desktop styles ── */
const d = {
  header: { borderBottom: "1px solid #e0e0e0", background: "#fff" },
  topBar: {
    display: "flex", gap: 16, padding: "6px 24px",
    borderBottom: "1px solid #e0e0e0", fontSize: 12, color: "#000",
  },
  topLink: { cursor: "pointer", color: "#000" },
  redTopLink: { cursor: "pointer", color: "#cd040b" },
  topSpacer: { flex: 1 },
  mainNav: { display: "flex", alignItems: "center", padding: "12px 24px", gap: 32 },
  logo: { marginRight: 8 },
  navLinks: { display: "flex", gap: 24, flex: 1 },
  navLink: { fontSize: 15, color: "#333", cursor: "pointer", fontWeight: 1000 },
  navRight: { display: "flex", alignItems: "center", gap: 16 },
  searchBox: {
    display: "flex", alignItems: "center", gap: 8,
    border: "1px solid #ccc", borderRadius: 100,
    padding: "13px", fontSize: 14, color: "#333",
  },
  searchText: { color: "#333" },
  signInLink: { fontSize: 15, color: "#333", fontWeight: 1000, cursor: "pointer" },
};